import { keepPreviousData, useQuery } from "@tanstack/react-query";

import sourcingService from "@services/sourcing.service";
import { QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS, SOURCING_SETTINGS_QUERY_KEY } from "@config/query";

export function useSourcingSettings() {
  return useQuery({
    queryKey: [SOURCING_SETTINGS_QUERY_KEY],
    queryFn: async () => {
      return await sourcingService.getSourcingSettings();
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS,
  });
}
